import React, {useEffect} from "react";
import {Skeleton, Splitter} from "antd";
import {AIAssistantChat} from "./AIAssistantChat";
import {useHistory, useParams} from "react-router-dom";
import {assistantService} from "../../../services/assistantService";
import {ExportPreview} from "./ExportPreview";
import {Spinner} from "../../../components/DesignSystem/Spinner/Spinner";
import {BackButton} from "../../../components/DesignSystem/BackButton/BackButton";
import {AlertIfMessage} from "../../../components/DesignSystem/AlertIfMessage/AlertIfMessage";
import {getErrorFromResponse} from "../../../utils/error.utils";
import {ExportDocumentIcon} from "../../../components/Export/ExportDocumentPublicUrl";

export const AIAssistantPage = ({user}) => {

    let {exportId} = useParams();
    let history = useHistory();

    const [preview, setPreview] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(null);
    const [sheetName, setSheetName] = React.useState(null);
    const [chatHistory, setChatHistory] = React.useState([]);


    useEffect(() => {

        assistantService.getHistory("export", exportId).then((response) => {
            setChatHistory(response);
        }).catch((error) => {
            console.error("Error fetching chat history:", error);
        });

        assistantService.fetchPreview(exportId).then(response => {
            setPreview(response.data);
        }).catch(e => {
            setError(getErrorFromResponse(e));
        }).finally(() => {
            setLoading(false);
        });


    }, [exportId]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleBack = () => {
        history.push(`/exports/${exportId}/snapshots`);
    }

    const onAsk = (message, sheetName, onSuccess, onError) => {
        assistantService.ask('export', exportId, message, sheetName).then(response => {
            onSuccess(response.data);
        }).catch(error => {
            console.log(error);
            onError(new Error(error));
        })
    }

    const handleSelectSheetName = (value) => {
        setSheetName(value);
    }

    if (preview === null) {
        return <div style={{padding: '20px'}}><Skeleton/></div>
    }

    return <Spinner spinning={loading} tip={"Loading data..."}>
        {error === null && (
            <Splitter style={{height: "100vh", paddingLeft: '2px'}}>
                <Splitter.Panel style={{background: "white"}} defaultSize="70%" min="5%">
                    <AIAssistantChat onAsk={onAsk} objectId={exportId} objectType={"export"}
                                     user={user}
                                     sheetName={sheetName} history={chatHistory}/>
                </Splitter.Panel>
                <Splitter.Panel style={{marginRight: "10px", marginLeft: "10px"}} min="5%">
                    {preview && <div>
                        <h4><BackButton onBack={handleBack}/>AI Assistant on {preview.name}{' '}
                            {<ExportDocumentIcon documentPublicUrl={preview?.documentPublicUrl} type={preview?.target}/>}
                        </h4>
                        <AlertIfMessage message={error}/>
                        <ExportPreview data={preview.data} onSelectSheet={handleSelectSheetName}/>
                    </div>}
                </Splitter.Panel>
            </Splitter>
        )}
    </Spinner>

}
